import { flow, makeObservable } from 'mobx'

import { STORE_UI } from 'Core/constants'
import { SortingParams } from 'Core/interfaces'
import { TableStore } from 'Core/stores/tableStore/TableStore'
import { storagePageSizeConstant } from 'Core/utils/storeHelpers/storagePageSizeConstant'

import { SiteDocument } from 'Portals/Customer/entities'
import { SiteDocumentRepo } from 'Portals/Customer/repositories'
import { RootStore } from 'Portals/Customer/stores'

const STORAGE_SITE_DOCUMENT_PAGE_SIZE = storagePageSizeConstant('siteDocument')

export class SiteDocumentTable extends TableStore<SiteDocument.Basic> {
	constructor(private rootStore: RootStore) {
		super(STORAGE_SITE_DOCUMENT_PAGE_SIZE)
	}

	@flow.bound
	*getItems(defaultSort?: SortingParams) {
		try {
			yield this.requestData({
				repository: SiteDocumentRepo.getList,
				defaultSort
			})
		} catch {
			this.rootStore[STORE_UI].showErrorNotification()
		}
	}
}
